const ParteMedicoIcon = ({ width, height }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? 15}
            height={height ?? width ?? 15}
            viewBox="0 0 28 28"
        >
            <g fill="none">
                <path
                    fill="url(#IconifyId194bcd372bc76b5f06)"
                    d="M21.5 7h2.25a2.25 2.25 0 0 1 2.245 2.096L26 9.25v11.5a3.25 3.25 0 0 1-3.066 3.245L22.75 24H21.5z"
                />
                <path
                    fill="url(#IconifyId194bcd372bc76b5f00)"
                    d="M5.25 24a3.25 3.25 0 0 1-3.245-3.066L2 20.75V6.25a2.25 2.25 0 0 1 2.096-2.245L4.25 4h15.5a2.25 2.25 0 0 1 2.245 2.096L22 6.25L21.995 24z"
                />
                <path
                    fill="url(#IconifyId194bcd372bc76b5f01)"
                    d="M5.25 24a3.25 3.25 0 0 1-3.245-3.066L2 20.75V6.25a2.25 2.25 0 0 1 2.096-2.245L4.25 4h15.5a2.25 2.25 0 0 1 2.245 2.096L22 6.25L21.995 24z"
                />
                <path
                    fill="url(#IconifyId194bcd372bc76b5f02)"
                    d="M5.25 24a3.25 3.25 0 0 1-3.245-3.066L2 20.75V6.25a2.25 2.25 0 0 1 2.096-2.245L4.25 4h15.5a2.25 2.25 0 0 1 2.245 2.096L22 6.25L21.995 24z"
                />
                <path
                    fill="url(#IconifyId194bcd372bc76b5f03)"
                    d="M10.247 13.004c.69 0 1.25.56 1.25 1.25v3.496c0 .69-.56 1.25-1.25 1.25H6.75c-.69 0-1.25-.56-1.25-1.25v-3.496c0-.69.56-1.25 1.25-1.25z"
                />
                <path
                    fill="url(#IconifyId194bcd372bc76b5f04)"
                    d="M14.25 17.5h3.496a.75.75 0 0 1 .102 1.493l-.102.007H14.25a.75.75 0 0 1-.102-1.493zh3.496zm0-4.497h3.496a.75.75 0 0 1 .102 1.493l-.102.007H14.25a.75.75 0 0 1-.102-1.493zh3.496z"
                />
                <path
                    fill="url(#IconifyId194bcd372bc76b5f05)"
                    d="M6.246 8.497h11.5a.75.75 0 0 1 .102 1.493l-.102.007h-11.5a.75.75 0 0 1-.102-1.494zh11.5z"
                />
                <defs>
                    <linearGradient
                        id="IconifyId194bcd372bc76b5f00"
                        x1="7.714"
                        x2="24.282"
                        y1=".923"
                        y2="21.365"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#3BD5FF" />
                        <stop offset="1" stopColor="#367AF2" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId194bcd372bc76b5f01"
                        x1="13.429"
                        x2="13.429"
                        y1="20.154"
                        y2="24"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset=".181" stopColor="#2764E7" stopOpacity="0" />
                        <stop offset="1" stopColor="#2764E7" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId194bcd372bc76b5f02"
                        x1="12.714"
                        x2="20.666"
                        y1="10.154"
                        y2="29.221"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#DCF8FF" stopOpacity="0" />
                        <stop offset="1" stopColor="#FF6CE8" stopOpacity=".7" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId194bcd372bc76b5f03"
                        x1="6.072"
                        x2="9.071"
                        y1="12.71"
                        y2="18.714"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#DEFCFF" />
                        <stop offset="1" stopColor="#9FF0F9" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId194bcd372bc76b5f04"
                        x1="13.937"
                        x2="15.121"
                        y1="13.109"
                        y2="19.47"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FDFDFD" />
                        <stop offset="1" stopColor="#CCEAFF" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId194bcd372bc76b5f05"
                        x1="-12.37"
                        x2="-12.335"
                        y1="7.415"
                        y2="10.299"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FDFDFD" />
                        <stop offset="1" stopColor="#CCEAFF" />
                    </linearGradient>
                    <radialGradient
                        id="IconifyId194bcd372bc76b5f06"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientTransform="matrix(-7.2 9.35006 -13.77599 -10.60817 28.7 9.55)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#068BEB" />
                        <stop offset=".617" stopColor="#0056CF" />
                        <stop offset=".974" stopColor="#0027A7" />
                    </radialGradient>
                </defs>
            </g>
        </svg>
    );
};

export default ParteMedicoIcon;
